import React from "react";
import Header from "../../Header/js/Header";
import IndustriesHero from "./IndustriesHero";
import IndustriesWB from "./IndustriesWB";
import Showcase from "../../Showcase/js/Showcase";
import industriesSeed from "../data/industries";
import useContent from "../../hooks/useContent";
import Footer from "../../Footer/js/Footer";

function Industries() {
  const items = useContent("industries", industriesSeed);
  return (
    <div className="Industries">
      <Header />
      <IndustriesHero />
      <IndustriesWB />
      <Showcase items={items} />
      <Footer />
    </div>
  );
}

export default Industries;
